import { ServiceContext } from 'providers/ServiceProvider';
import { useContext } from 'react';
import { useSubscription as useApolloSubscription } from '@apollo/client'; // eslint-disable-line no-restricted-imports
import { useSimpleError } from 'hooks/apolloWrappers';

const useSubscription = (subscription, options) => {
  const [activeService] = useContext(ServiceContext);
  const showError = useSimpleError();

  return useApolloSubscription(subscription, {
    ...options,
    context: { serviceName: activeService?.name },
    skip: options?.skip || !activeService?.name,
    onError: error => {
      showError(error);
      options?.onError && options.onError(error);
    }
  });
};

export default useSubscription;
